// extracted by mini-css-extract-plugin
export default {"container":"styles_container__sfDdS","label":"styles_label__XEwol","select":"styles_select__ya++0"};